import { useEffect, useMemo, useState } from "react";
import TreeAPI from "../../apis/TreeAPI";
import produce from "immer";


const useLessons = (props: IUseLessonsProps) => {
    const [lessons, setLessons] = useState<{
        [key: string]: IDBRealtimeLesson | undefined;
    }>({});

    useEffect(() => {
        setLessons({});
        if (props.chapterId === undefined) return;
        const unsubscribe = TreeAPI.subscribeToLessons(
            props.chapterId,
            (lesson: IDBRealtimeLesson) => {
                setLessons(
                    produce(draft => {
                        draft[lesson.id] = lesson;
                    })
                );
            },
            (id: string) => {
                setLessons(
                    produce(draft => {
                        draft[id] = undefined;
                    })
                );
            }
        );
        return () => unsubscribe();
    }, [props.chapterId]);

    const lessonsArray = useMemo(() => {
        const keys = Object.keys(lessons);
        const result: IDBRealtimeLesson[] = [];

        keys.forEach(key => {
            const lesson = lessons[key];
            if (lesson !== undefined)
                result.push(lesson);
        });

        result.sort((a, b) => a.order - b.order);

        return result;
    }, [lessons]);

    return { lessons, lessonsArray };

}

export { useLessons }